<p-dialog #deletepopup id="deletepopupid" class="delConfirm" [(visible)]="dialogVisible" [modal]="true" [header]="confirmationHeader" [responsive]="true" [baseZIndex]="10000" (onHide)="onDialogHide()">
    <p class="text-center">{{confirmationMessage}}</p>
    <p-footer>
      <button type="button" pButton icon="pi pi-check"   (click)="confirmDelete()">Yes</button>
      <button type="button" pButton icon="pi pi-times" (click)="hideDeleteDialog()" class="p-button-secondary">No</button>
    </p-footer>
  </p-dialog>
  